import React, { useState, useEffect } from "react";
import { Stack } from "@mui/material";
import { context_header_styles } from "./mi_styles";
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import "./mi.css";
import { useDrag } from '@use-gesture/react';
import { useSpring, animated } from '@react-spring/web';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Collapse } from "@mui/material";
import { miActions } from "../store/store";
import { useSelector, useDispatch } from "react-redux";
import { MiSnackbar } from "./miComponents/snackbar";
import { DotLoader } from "./miComponents/dot_loader";
import moment from "moment";
import Default from "./pages/default";
import Preferences from "./pages/preferences";

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function MiWidget(props) {
  const pos = useSelector(state => state.miStore.pos);
  const openContext = useSelector(state => state.miStore.openContext);
  const selectedPage = useSelector(state => state.miStore.page);
  const dispatch = useDispatch();

  const bind = useDrag(({ event, offset: [x, y] }) => {
    const targetClasses = event.target.classList;

    // Check if the drag icon is being dragged
    if (targetClasses.contains('drag-indicator-dark')) {
      dispatch(miActions.setPos({ x: x + (window.innerWidth - 325), y: y + 100 }))
    }
  });

  const navigate = useNavigate();
  const [springs, api] = useSpring(() => ({
    from: {
      x: window.innerWidth - 300
    },
    config: {
      mass: 2.5,
    }
  }))

  useEffect(() => {
    dispatch(miActions.setPos(pos));
  }, [pos, dispatch]);
  

  useEffect(() => {
    api.start({
      from: {
        x: "-100%",
        scale: 0
      },
      to: {
        x: "0%",
        scale: 1
      }
    })
  }, [openContext])

  const handleContextOpen = () => {
    dispatch(miActions.setPos({ x: pos.x, y: pos.y }));
    dispatch(miActions.setopenContext(!openContext))
  }

  useEffect(() => { }, [selectedPage])

  useEffect(() => {
    setInterval(() => {
      const updatedDateTime = moment(new Date()).format("MMM DD, YYYY hh:mm:ss a");
      dispatch(miActions.updateDateTime(updatedDateTime))
    }, 1000)
  }, [])

  const handlePageChange = () => {
    dispatch(miActions.changePage("preferences"));
    dispatch(miActions.setPrevPage(selectedPage));
  }

  const pages = [
    {
      name: "default",
      page: (
        <Default />
      )
    },
    {
      name: "preferences",
      page: (
        <Preferences />
      )
    }
  ]

  const currentPage = pages.filter(page => page.name === selectedPage)[0]["page"]

  return (
    <animated.div
      {...bind()}
      style={{
        position: "fixed",
        zIndex: 999,
        top: pos.y,
        left: pos.x,
        // ...springs,
      }}
    >

      <Stack spacing={0.7}>
        <div className="drag-indicator-dark" style={context_header_styles}>
          <div
            onClick={handleContextOpen}
            style={{
              color: "rgb(250,250,250)",
              fontSize: "1.25rem",
              letterSpacing: "0.02rem",
              cursor: "pointer",
              textShadow: "0 0 3px #fff",
              fontFamily: 'Virgil'
            }}
          >
            MI
          </div>
          <div style={{ justifyContent: "center", alignItems: "center" }}>
            <DotLoader />
          </div>
          <DragIndicatorIcon
            sx={{ fontSize: '1.7rem', cursor: 'pointer', transform: "rotate(90deg)"}} 
            onClick={handlePageChange}
          />
        </div>

        <Collapse in={openContext} timeout={350} unmountOnExit>
          {currentPage}
        </Collapse>

        <MiSnackbar />
      </Stack>
    </animated.div>
  )
}